<template>
    <form @submit.prevent="save" class="clearfix pb-4">
        <top-nav-bar :goto="backPath"></top-nav-bar>

        <template v-if="step === 'information'">
            <form-group label="Flight #" name="flight_no" :required="true">
                <div class="select">
                    <select name="flight_no" v-model="report.flight_no" class="input">
                        <option value="">Select a flight #</option>
                        <option v-for="flight in flights" :value="flight">
                            {{flight}}
                        </option>
                    </select>
                </div>
            </form-group>

            <form-group label="STD" name="std" :required="true">
                <time-field
                    id="std"
                    class="input"
                    name="std"
                    v-model="report.std"
                />
            </form-group>

            <form-group label="ATD" name="atd" :required="true">
                <time-field
                    id="atd"
                    class="input"
                    name="atd"
                    v-model="report.atd"
                />
            </form-group>

            <form-group label="Date" name="date" :required="true">
                <datepicker
                    placeholder="Select date"
                    id="date"
                    name="date"
                    :min-date="minStartDate"
                    v-model="report.date"
                />
            </form-group>

            <form-group label="Passengers (J-class)" name="j_class" :required="true">
                <input type="text" name="j_class" class="input" v-model="report.j_class">
            </form-group>

            <form-group label="Passengers (Y-class)" name="y_class" :required="true">
                <input type="text" name="y_class" class="input" v-model="report.y_class">
            </form-group>

            <form-group label="Aircraft Registration" name="aircraft_reg" :required="true">
                <input type="text" name="aircraft_reg" class="input" v-model="report.aircraft_reg">
            </form-group>

            <form-group label="SCC L1" name="scc_l1" :required="true">
                <div class="select">
                    <select name="scc_l1" id="scc_l1" class="input" v-model="report.scc_l1">
                        <option value="">Select crew</option>
                        <option v-for="user in users" :value="user.id">{{user.employee_id}} - {{user.name}}</option>
                    </select>
                </div>
            </form-group>

            <form-group label="SCC L4" name="scc_l4" :required="true">
                <div class="select">
                    <select name="scc_l4" id="scc_l4" class="input" v-model="report.scc_l4">
                        <option value="">Select crew</option>
                        <option v-for="user in users" :value="user.id">{{user.employee_id}} - {{user.name}}</option>
                    </select>
                </div>
            </form-group>

            <form-group label="Crew Count (J-class)" name="crew_count_j_class" :required="true">
                <input type="text" name="crew_count_j_class" class="input" v-model="report.crew_count_j_class">
            </form-group>

            <form-group label="Crew Count (Y-class)" name="crew_count_y_class" :required="true">
                <input type="text" name="crew_count_y_class" class="input" v-model="report.crew_count_y_class">
            </form-group>
        </template>

        <template v-if="step === 'times'">
            <h4>Times</h4>

            <form-group label="Crew at Aircraft" name="crew_at_aircraft" help="(60 min prior STD)">
                <time-field
                    id="crew_at_aircraft"
                    class="input"
                    name="crew_at_aircraft"
                    v-model="report.crew_at_aircraft"
                />
            </form-group>

            <form-group label="All crew documents OK" name="crew_documents_ok">
                <label class="checkbox">
                    <input type="checkbox" name="crew_documents_ok" v-model="report.crew_documents_ok">
                    <span>Yes</span>
                </label>
            </form-group>

            <form-group label="Boarding Start" name="boarding_start" help="(40 min prior STD. Please specify, if delayed)">
                <time-field
                    id="boarding_start"
                    class="input"
                    name="boarding_start"
                    v-model="report.boarding_start"
                />
            </form-group>

            <form-group label="Door Closed" name="door_closed" help="(2 min prior STD, Please specify, if delayed)">
                <time-field
                    id="door_closed"
                    class="input"
                    name="door_closed"
                    v-model="report.door_closed"
                />
            </form-group>

            <form-group label="First Service Start (J and Y Class)" name="first_service_start_jy" help="(Please specify, if delayed)">
                <input type="number" name="first_service_start_jy" class="input" v-model="report.first_service_start_jy">
            </form-group>

            <form-group label="First Service End (J Class)" name="first_service_end_j" help="Minutes from takeoff<br>(Night; 120 min/ Day; 150 min after ATD)">
                <input type="number" name="first_service_end_j" class="input" v-model="report.first_service_end_j">
            </form-group>

            <form-group label="First Service End (Y Class)" name="first_service_end_y" help="Minutes from takeoff<br>(Night; 120 min/ Day; 150 min after ATD)">
                <input type="number" name="first_service_end_y" class="input" v-model="report.first_service_end_y">
            </form-group>

            <form-group label="Second Service Start (J and Y Class)" name="second_service_start_jy" help="(Please specify, if delayed)">
                <input type="number" name="second_service_start_jy" class="input" v-model="report.second_service_start_jy">
            </form-group>

            <form-group label="Second Service End (J Class)" name="second_service_end_j" help="(Hot BF; 90 min, cold BF 45 min prior ETA / Daytime; hot 90 min, cold 40 min, drinks/snacks 20 min prior ETA)">
                <input type="number" name="second_service_end_j" class="input" v-model="report.second_service_end_j">
            </form-group>

            <form-group label="Second Service End (Y Class)" name="second_service_end_y" help="(BF night; 150 min prior ETA/BF day 120 min prior ETA) ">
                <input type="number" name="second_service_end_y" class="input" v-model="report.second_service_end_y">
            </form-group>
        </template>

        <template v-if="step === 'remarks'">
            <h4>Remarks</h4>

            <form-group label="Uniform Grooming Check" name="uniform_grooming_check">
                <label class="checkbox">
                    <input type="checkbox" name="uniform_grooming_check" v-model="report.uniform_grooming_check">
                    <span>Yes</span>
                </label>
            </form-group>

            <form-group label="Crew Rest According to Rules" name="crew_rest_acc_to_rules">
                <label class="checkbox">
                    <input type="checkbox" name="crew_rest_acc_to_rules" v-model="report.crew_rest_acc_to_rules">
                    <span>Yes</span>
                </label>
            </form-group>

            <form-group label="Onboard Sales" name="onboard_sales">
                <input type="text" name="onboard_sales" class="input" v-model="report.onboard_sales">
            </form-group>

            <form-group label="Sales Report" name="sales_report">
                <textarea name="sales_report" class="input" id="sales_report" rows="10" v-model="report.sales_report"></textarea>
            </form-group>

            <form-group label="Closing the flight and feedback" name="closing_and_flight_feedback">
                <label class="checkbox">
                    <input type="checkbox" name="closing_and_flight_feedback" v-model="report.closing_and_flight_feedback">
                    <span>Yes</span>
                </label>
            </form-group>

            <form-group label="Other remarks" name="other_remarks" help="If any box checked with false, or something to specify, state the reason(s) here">
                <textarea name="other_remarks" class="input" id="other_remarks" rows="10" v-model="report.other_remarks"></textarea>
            </form-group>
        </template>

        <template v-if="step === 'reporting'">
            <h4>Reporting</h4>
            <reportable :data-reporting="report.reporting"></reportable>

        </template>

        <div class="block md:inline-flex md:float-right">
            <button class="btn btn--colored__blue w-full" type="submit" v-html="buttonText"></button>
        </div>
    </form>
</template>

<script>
import InteractsWithDates from '@/mixins/InteractsWithDates'
import Reportable from '../Reportable.vue'
import NeedsUsers from '@/mixins/NeedsUsers'
import HasSteps from '@/mixins/HasSteps'
import IsReport from '@/mixins/IsReport'
import SetsReportData from '@/mixins/SetsReportData'
export default {
    components: {Reportable},

    mixins: [InteractsWithDates, NeedsUsers, HasSteps, IsReport, SetsReportData],

    data() {
        return {
            type: 'daily-flight',
            steps: [
                {name: 'Information', id: 'information'},
                {name: 'Remarks', id: 'remarks'},
                {name: 'Reporting', id: 'reporting'},
            ],
            report: {
                flight_no: '',
                std: '',
                atd: '',
                date: '',
                j_class: '',
                y_class: '',
                aircraft_reg: '',
                scc_l1: null,
                scc_l4: null,
                crew_count_j_class: '',
                crew_count_y_class: '',
                crew_at_aircraft: '',
                crew_documents_ok: false,
                boarding_start: '',
                door_closed: '',
                first_service_start_jy: '',
                first_service_end_j: '',
                first_service_end_y: '',
                second_service_start_jy: '',
                second_service_end_j: '',
                second_service_end_y: '',
                uniform_grooming_check: false,
                crew_rest_acc_to_rules: false,
                onboard_sales: '',
                sales_report: '',
                closing_and_flight_feedback: false,
                other_remarks: '',
                reporting: {},
            }
        }
    },

    created() {
        if(this.$parent.reportData) {
            this.setData(this.$parent.reportData, ['flight_no', 'std', 'date'])
            this.setData(this.$parent.reportData.scc_l1, 'scc_l1', 'id')
            this.setData(this.$parent.reportData.scc_l4, 'scc_l4', 'id')
            this.setData(this.$parent.reportData.content, 'reporting')
            this.setData(this.$parent.reportData.content, [
                'atd', 'aircraft_reg', 'crew_count_j_class', 'crew_count_y_class', 'j_class', 'y_class'
            ])
            this.setData(this.$parent.reportData.content, [
                'boarding_start', 'crew_at_aircraft', 'crew_documents_ok', 'door_closed',
                'first_service_end_j', 'first_service_end_y', 'first_service_start_jy',
                'second_service_end_j', 'second_service_end_y', 'second_service_start_jy',
            ], 'times')
            this.setData(this.$parent.reportData.content, [
                'closing_and_flight_feedback', 'crew_rest_acc_to_rules', 'onboard_sales', 'other_remarks', 'sales_report', 'uniform_grooming_check',
            ], 'remarks')
        }
    },

    computed: {
        flights() {
            return this.$parent.flights
        },
    },
}
</script>
